const ajuste_inventario = state => state.ajuste_inventario;

export default {
  ajuste_inventario,
};